import { RobotOutlined } from "@ant-design/icons";
import type { AIPlatform } from "@p0security/shared/types/ai-inventory";

import { PLATFORM_META } from "./meta.ts";

export type PlatformIconProps = {
  platform: AIPlatform;
  /** Pixel box-size. */
  size?: number;
};

/**
 * Renders the platform's native logo when we have one, otherwise a generic
 * robot glyph. Used on AgentRow, graph AgentNode, and the platform selector.
 */
export const PlatformIcon: React.FC<PlatformIconProps> = ({
  platform,
  size = 16,
}) => {
  const url = PLATFORM_META[platform].iconUrl;
  if (url) {
    return (
      <img
        src={url}
        alt=""
        aria-hidden
        style={{
          width: size,
          height: size,
          objectFit: "contain",
          display: "inline-block",
        }}
      />
    );
  }
  return <RobotOutlined style={{ fontSize: size }} />;
};
